/**
 * Logo CloudHesive — usa los SVG oficiales del brand-book.
 *
 *  - `variant="full"` (default): logo full con AWS Premier Tier Partner.
 *      `tone="navy"` para fondos claros, `tone="white"` para fondos oscuros.
 *  - `variant="mark"`: solo el isotipo (mark navy).
 */
type Variant = 'full' | 'mark';
type Tone = 'navy' | 'white';

interface LogoProps {
  className?: string;
  variant?: Variant;
  tone?: Tone;
}

export default function Logo({
  className = 'h-8',
  variant = 'full',
  tone = 'navy',
}: LogoProps) {
  const src =
    variant === 'mark'
      ? '/cloudhesive-mark.svg'
      : tone === 'white'
        ? '/cloudhesive-logo-white.svg'
        : '/cloudhesive-logo.svg';

  return <img src={src} alt="CloudHesive" className={className} />;
}
